module.exports = __webpack_public_path__ + "img/IMG_7243.630dd439.jpg";